import gql from 'graphql-tag';

export const fields = `
    tenantIds
    fleetId
    fleet {
        id
        tenantIds
        companyId
        hasOpenIssues
        hasAiPredictions
        hasSchedule
    }
    name
    type
    link
    sort
    isMaster
    isActive
    chartTypeId
    chartType {
        id
        value
    }
    title
    enginesJoin
    createdAt
    updatedAt
`;

export const relationsFields = `
    digitaiGetChartTypes (
        query: $queryChartTypes
        constraint: $constraintChartTypes
    ) {
        id
        value
    }
`;

// default methods
export const paginationQuery = gql`
    query DigitaiPaginateFleetTabs (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        pagination: digitaiPaginateFleetTabs (
            query: $query
            constraint: $constraint
        ) {
            total
            rows
            count
        }
    }
`;

export const getQuery = gql`
    query DigitaiGetFleetTabs (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        objects: digitaiGetFleetTabs (
            query: $query
            constraint: $constraint
        ) {
            id
            #FIELDS
        }
    }
`;

export const getRelations = gql`
    query DigitaiGetFleetTabsRelations (
        $queryChartTypes: QueryStatement
        $constraintChartTypes: QueryStatement
    ) {
        ${relationsFields}
    }
`;

export const findByIdQuery = gql`
    query DigitaiFindFleetTabById (
        $id: ID
        $constraint: QueryStatement
    ) {
        object: digitaiFindFleetTabById (
            id: $id
            constraint: $constraint
        ) {
            id
            #FIELDS
        }
    }
`;

export const findByIdWithRelationsQuery = gql`
    query DigitaiFindFleetTabByIdWithRelations (
        $id: ID
        $constraint: QueryStatement
        $queryChartTypes: QueryStatement
        $constraintChartTypes: QueryStatement
    ) {
        object: digitaiFindFleetTabById (
            id: $id
            constraint: $constraint
        ) {
            id
            #FIELDS
        }
        ${relationsFields}
    }
`;

export const findQuery = gql`
    query DigitaiFindFleetTab (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        object: digitaiFindFleetTab (
            query: $query
            constraint: $constraint
        ) {
            id
            #FIELDS
        }
    }
`;

export const createMutation = gql`
    mutation DigitaiCreateFleetTab (
        $payload: DigitaiCreateFleetTabInput!
    ) {
        digitaiCreateFleetTab (
            payload: $payload
        ) {
            ${fields}
        }
    }
`;

export const insertMutation = gql`
    mutation DigitaiCreateFleetTabs (
        $payload: [DigitaiCreateFleetTabInput]!
    ) {
        digitaiCreateFleetTabs (
            payload: $payload
        )
    }
`;

export const updateByIdMutation = gql`
    mutation DigitaiUpdateFleetTabById (
        $payload: DigitaiUpdateFleetTabByIdInput!
        $constraint: QueryStatement
    ) {
        digitaiUpdateFleetTabById (
            payload: $payload
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const updateMutation = gql`
    mutation DigitaiUpdateFleetTabs (
        $payload: DigitaiUpdateFleetTabsInput!
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        digitaiUpdateFleetTabs (
            payload: $payload
            query: $query
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const deleteByIdMutation = gql`
    mutation DigitaiDeleteFleetTabById (
        $id: ID!
        $constraint: QueryStatement
    ) {
        digitaiDeleteFleetTabById (
            id: $id
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const deleteMutation = gql`
    mutation DigitaiDeleteFleetTabs (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        digitaiDeleteFleetTabs (
            query: $query
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;
